<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-2 py-lg-7 pt-lg-4">
      <b-container fluid>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Choose the best plan for your business</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container fluid class="mt--9 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="10">
          <b-card-group class="pricing flex-column flex-md-row mb-1">
            <card header-classes="bg-transparent p-0"
                  body-classes="px-lg-7 pt-2"
                  class="card-pricing border-0 text-center mb-4"
                  footer-classes="p-2">
              <h4 slot="header" class="text-uppercase ls-1 text-primary py-2 mb-0">Plus Plan</h4>

              <div class="display-3">$59/mo</div>
              <!-- <span class="text-muted">per application</span> -->
              <ul class="list-unstyled my-1">
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                        <i class="fa fa-plus"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2">Create Issue</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                        <i class="fa fa-link"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2">Link existing issue</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                        <i class="fa fa-history"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2">View  Log and Status</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                        <i class="fa fa-comment-alt"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2">Notify Issue</span>
                    </div>
                  </div>
                </li>
                <!-- <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                        <i class="fa fa-sticky-note"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2">Complete documentation</span>
                    </div>
                  </div>
                </li> -->
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-gradient-primary shadow rounded-circle text-white">
                        <i class="fa fa-question"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2">Limited Support</span>
                    </div>
                  </div>
                </li>
              </ul>

              <!-- <base-button type="primary" class="mb-3">Start free trial</base-button> -->

              <router-link slot="footer" to="/contact" class="text-light">Contact Sales</router-link>
            </card>

            <card gradient="info"
                  class="card-pricing zoom-in shadow-lg rounded border-0 text-center mb-4"
                  header-classes="bg-transparent p-0"
                  body-classes="px-lg-7 pt-2"
                  footer-classes="bg-transparent p-2"
            >
              <h4 slot="header" class="text-uppercase ls-1 text-white py-2 mb-0">Premium Plan</h4>

              <div class="display-3 text-white">$125/mo *</div>
              <!-- <span class="text-white">per application</span> -->
              <ul class="list-unstyled my-1">
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-white shadow rounded-circle text-info">
                        <i class="fa fa-sync"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">Two-way comment syncing (+50$ per mo)</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-white shadow rounded-circle text-info">
                        <i class="fa fa-rocket"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">Status syncing (+20$ per mo)</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-white shadow rounded-circle text-info">
                        <i class="fa fa-question"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">Premium Support</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-white shadow rounded-circle text-info">
                        <i class="fa fa-laptop"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">On-Premise Support (+25$ per mo)</span>
                    </div>
                  </div>
                </li>
                <li>
                  <div class="d-flex align-items-center">
                    <div>
                      <div class="icon icon-xs icon-shape bg-white shadow rounded-circle text-info">
                        <i class="fa fa-edit"></i>
                      </div>
                    </div>
                    <div>
                      <span class="pl-2 text-white">Advanced customization *</span>
                    </div>
                  </div>
                </li>
              </ul>

              <!-- <base-button type="secondary" class="mb-3">Start free trial</base-button> -->

              <router-link slot="footer" to="/contact" class="text-white">Contact Sales</router-link>
            </card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-row class="row-grid justify-content-center">
        <b-col lg="10">
          <div class="table-responsive" style="overflow-x:hidden!important;">
            <base-table class="table table-dark mt-3"
                        :data="features">
              <template slot="columns">
                <th class="px-0 bg-transparent" scope="col">
                  <span class="text-light font-weight-700">Features</span>
                </th>
                <th class="text-center bg-transparent" scope="col">Plus Plan</th>
                <th class="text-center bg-transparent" scope="col">Premium Plan</th>
              </template>

              <template slot-scope="{row}">
                <td class="px-0 text-info">{{row.title}}</td>
                <td class="text-center" v-html="row.plus"></td>
                <td class="text-center" v-html="row.premium"></td>
              </template>

            </base-table>
          </div>
        </b-col>
      </b-row>
      <!-- <div class="d-flex justify-content-lg-center px-3 mt-5">
        <div>
          <div class="icon icon-shape bg-gradient-white shadow rounded-circle text-primary">
            <i class="fa fa-dollar-sign text-primary"></i>
          </div>
        </div>
        <b-col lg="10">
          <p class="text-white"><strong>Contact us for pricing quote on </strong> Zendesk - Azure DevOps Integration, 
          Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration.</p>
        </b-col>
      </div> -->
    </b-container>
    <!-- Contact Section End -->
    <PricingQuote :contact="false" :quote="true"></PricingQuote>
  </div>
</template>
<script>
  import PricingQuote from '@/components/pricing-quote/pricing-quote.vue'
  import BaseTable from '@/components/BaseTable';
  import FeaturesJSON from '@/data/features-github.js';
  export default {
    name: 'pricing-page',
    components:{BaseTable,PricingQuote},
    data() {
      return {
        features:[],
      }
    },
    created(){
      this.features=FeaturesJSON;
    }
  };
</script>
<style scoped>
.card-pricing .list-unstyled li{
  padding: .3rem 0;
}
</style>
